import styled from 'styled-components';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 16px;
  height: 100vh;
  width: 100vw;
  position: relative;
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  position: absolute;
  height: 80px;
  top: calc(50% - 100px);

  h1 {
    color: ${(props) => props.theme.colors.primary};
    font-size: 1.4rem;
    user-select: none;
  }
`;
